module.exports = __webpack_public_path__ + "img/kp.d9a9575f.jpg";